/**
 * @file picking-items-text.ts
 * @description Состав задания одной-двумя строками для списков (phase19.31,
 * шаг О4; макет (г)): «Алтайская магия ×2» и «Лаванда саше ×1 · +2 ещё».
 *
 * В строке таблицы 56px прежний столбик из трёх наименований не
 * помещается: первая строка — первое наименование, подпись — второе и
 * «+N ещё». В компактном списке состав — одной строкой через запятую.
 * Единицу дописываем, только если она не «шт» — как было в очереди до О4.
 */

import type { PickingTaskItemPreviewDto, PickingTaskListItemDto } from "../../../lib/api-picking";
import { PICK_UNIT_FALLBACK, formatQtyValue } from "../../../lib/picking-format";

/** «Иван-чай 50 г ×3», «Мёд ×2 кг». */
export function previewItemText(item: PickingTaskItemPreviewDto): string {
  const unit = item.unit && item.unit !== PICK_UNIT_FALLBACK ? ` ${item.unit}` : "";
  return `${item.name} ×${formatQtyValue(item.qty)}${unit}`;
}

/** Сколько строк задания не показано: «+2 ещё»; все видны — пусто. */
function restText(task: PickingTaskListItemDto, shown: number): string {
  const rest = task.itemsTotal - shown;
  return rest > 0 ? `+${rest} ещё` : "";
}

/** Первая строка состава (таблица): первое наименование. */
export function itemsFirstLine(task: PickingTaskListItemDto): string {
  const first = task.itemsPreview[0];
  return first ? previewItemText(first) : "—";
}

/** Подпись состава (таблица): второе наименование и «+N ещё». */
export function itemsSecondLine(task: PickingTaskListItemDto): string {
  const second = task.itemsPreview[1];
  const shown = second ? 2 : Math.min(1, task.itemsPreview.length);
  return [second ? previewItemText(second) : "", restText(task, shown)].filter(Boolean).join(" · ");
}

/** Состав одной строкой (компактный список): «Алтайская магия ×2, Лаванда ×1 +2 ещё». */
export function itemsOneLine(task: PickingTaskListItemDto): string {
  const names = task.itemsPreview.map(previewItemText).join(", ");
  const rest = restText(task, task.itemsPreview.length);
  return [names, rest].filter(Boolean).join(" ") || "—";
}

/** Кто взял задание: «вы», имя или «не взято». */
export function assigneeText(task: PickingTaskListItemDto, currentUserId: string | null, empty = "не взято"): string {
  if (!task.assignee) return empty;
  return task.assignee.id === currentUserId ? "вы" : (task.assignee.displayName ?? "другой сотрудник");
}
